import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeone-services',
  templateUrl: './homeone-services.component.html',
  styleUrls: ['./homeone-services.component.scss']
})
export class HomeoneServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
